import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as moment from 'moment';

@Component({
  selector: 'app-forum-form',
  templateUrl: './forum-form.component.html',
  styleUrls: ['./forum-form.component.scss'],
  providers: [
    AngularFireDatabase,
    AngularFireAuth
  ]
})
export class ForumFormComponent implements OnInit {
  @Input() topicId : any;
  question : any = {};
  forumRef : any;
  user : any;
  profile : any = {
    avatarUrl: '/asssets/img/avatar.png',
  }

  constructor(private db: AngularFireDatabase, private afAuth: AngularFireAuth) {

  }

  ngOnInit() {
    this.forumRef = this.db.list('discussions/');
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
      const subscription = this.db.object(`profiles/${user.uid}`)
      .valueChanges().subscribe(snapshot => {
        subscription.unsubscribe();
        Object.assign(this.profile, snapshot);
      })
    })

  }

  sendQuestion() {
    this.question.date = moment().format('YYYY-MM-DD HH:mm:ss');
    this.question.userId = this.user.uid;
    this.question.topicId = this.topicId;
    this.question.displayName = this.user.displayName;

    this.forumRef.push(this.question)
      .then(result => {
        this.question = {};
      });
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-form/forum-form.component.ts